import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  HostListener,
  PLATFORM_ID,
  Inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar';
import { TopBarComponent } from '../top-bar/top-bar';
import { MobileHeaderComponent } from '../mobile-header/mobile-header';
// import { TabletHeaderComponent } from '../tablet-header/tablet-header';
import { DesktopHeaderComponent } from '../desktop-header/desktop-header';
import { StickyHeaderComponent } from '../sticky-header/sticky-header';
import { isPlatformBrowser } from '@angular/common';

interface FinalHeaderProps {
  showSidebar?: boolean;
}

@Component({
  selector: 'allas-header',

  imports: [
    CommonModule,
    SidebarComponent,
    TopBarComponent,
    MobileHeaderComponent,
    // TabletHeaderComponent,
    DesktopHeaderComponent,
    StickyHeaderComponent,
  ],
  templateUrl: 'header.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() showSidebar: boolean = true;

  isSidebarOpen: boolean = false;
  searchQuery: string = '';
  isScrolled: boolean = false;

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    // this.handleScroll();
  }

  ngOnDestroy(): void {
    // Cleanup if needed
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.handleScroll();
  }

  private handleScroll(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.isScrolled = window.scrollY > 100;
    }
  }

  toggleSidebar(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  onSearchChange(searchValue: string): void {
    this.searchQuery = searchValue;
  }

  onCloseSidebar(): void {
    this.isSidebarOpen = false;
  }
}
